import { useFlags } from 'launchdarkly-react-client-sdk'

/**
 * Hook to check if handlebar templates are enabled
 * @returns {boolean} True if handlebar templates are enabled, false otherwise
 */
export const useHandlebarTemplates = () => {
  const flags = useFlags() || {}
  return flags?.plat2981AllowHandlebarTemplates ?? false
}
